import wbEventBannerTemplate from './event_banner.template.html';

class eventBannercontroller {

    constructor($scope) {
        'ngInject';

        const injectables = {
            $scope
        };

        Object.assign(this, injectables);
    }
    $onInit() {
    }

}

angular.module('westBerkshireEvents.banner').component('wbBanner', {
    templateUrl: wbEventBannerTemplate.id,
    controller: eventBannercontroller,
    controllerAs: '$eventBannerCtrl',
    bindings: {
        event: '<',
        bb: '<'
    },
});



// WEBPACK FOOTER //
// ../src/public/javascripts/event-banner/event_banner.component.js